module.exports = __webpack_public_path__ + "static/media/img008.2c587f9f.jpg";